export enum UserRole {
    customer = 0,
    admin = 2,
    staff = 3,
    vendor = 6,
    manager = 7,
    readOnlyUser = 8,
    client = 9,
}
